import {
  IProducto,
  IpagoByIdPoliza,
  IPolizaPagoPendiente,
} from './../../shared/Entities/entities';
import { ProductService } from './../../shared/services/product.service';
import { Component, OnInit } from '@angular/core';
import { getArraySumByField } from 'src/app/shared/helpers/helper';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';
import { tipoPrima } from '@app/shared/helpers/constants';

@Component({
  selector: 'app-pagar-mis-productos',
  templateUrl: './pagar-mis-productos.component.html',
  styleUrls: ['./pagar-mis-productos.component.sass'],
})
export class PagarMisProductosComponent implements OnInit {
  productos: IProducto[] = [];
  dataAPagar: IpagoByIdPoliza[] = [];
  checkedPays: IPolizaPagoPendiente[] = [];
  total = 0;
  modoPago = false;
  constructor(
    private productSrv: ProductService,
    private appInsightsService: AppInsightsService
  ) {}

  ngOnInit(): void {
    this.productSrv.listarLineaNegocio().subscribe(lineasNegocios => {
      if (!lineasNegocios) {
        return;
      }
      const lineaIndividuales = lineasNegocios.find(
        l => l.LineaNegocio === 'SEGURO INDIVIDUAL'
      );

      this.productos = lineaIndividuales.ListaProductos.Producto;
    });
  }

  getDataAPagar(data: IpagoByIdPoliza) {
    const element = this.dataAPagar.find(d => d.idPoliza === data.idPoliza);
    if (!element) {
      this.dataAPagar.push(data);
    } else {
      element.checkedPays = data.checkedPays;
    }

    let arrayLocal = [];
    this.dataAPagar.forEach(d => {
      arrayLocal = arrayLocal.concat(d.checkedPays);
    });

    this.total = getArraySumByField(arrayLocal, 'Monto');
  }

  onPagar() {
    this.appInsightsService.trackEvent(Event.iidpBtnPayStepper);
    this.modoPago = true;
    this.checkedPays = [];
    this.dataAPagar.forEach(d => {
      this.checkedPays = this.checkedPays.concat(d.checkedPays);
    });
  }

  closeWebPay(event) {
    this.modoPago = false;
    this.checkedPays = [];
    this.dataAPagar = [];
  }

  expandChange(nameProduct: string) {
    this.appInsightsService.trackEvent(Event.accShowProduct, { nameProduct });
  }
}
